
import { useAuth } from "@/context/AuthContext";
import { ModuleType, UseAutomatedMessagesReturn } from "./automated-messages/types";
import { useAutomatedMessagesQuery } from "./automated-messages/queries";
import { 
  useCreateMessageMutation, 
  useUpdateMessageMutation, 
  useDeleteMessageMutation, 
  useToggleActiveMutation 
} from "./automated-messages/mutations";

export type { ModuleType };

export const useAutomatedMessages = (moduleType: ModuleType): UseAutomatedMessagesReturn => {
  const { user } = useAuth();

  // Fetch messages
  const { data: messages = [], isLoading, error } = useAutomatedMessagesQuery(moduleType, user?.id);

  // Mutations
  const createMessageMutation = useCreateMessageMutation(moduleType, user?.id);
  const updateMessageMutation = useUpdateMessageMutation(moduleType, user?.id);
  const deleteMessageMutation = useDeleteMessageMutation(moduleType, user?.id);
  const toggleActiveMutation = useToggleActiveMutation(moduleType, messages, user?.id);

  return {
    messages,
    isLoading,
    error,
    createMessage: createMessageMutation.mutate,
    updateMessage: updateMessageMutation.mutate,
    deleteMessage: deleteMessageMutation.mutate,
    toggleActive: toggleActiveMutation.mutate,
    isCreating: createMessageMutation.isPending,
    isUpdating: updateMessageMutation.isPending,
    isDeleting: deleteMessageMutation.isPending,
    isToggling: toggleActiveMutation.isPending,
  };
};
